import HttpRequest from './http_request'

class ReportsProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT + 'admission/api/')
  }

  async getCurriculumCountSummary(year_id) {
    const { data } = await this.get('/', {
      function: 'get-curriculum-count-summary',
      YEAR_ID: year_id,
      // where: [{YEAR_ID: year_id}]
    })
    return data
  }

  async getNameListSummary({ year_id, round_id, project_id, master_reg_curriculum_id, register_status_id, static_list, refused, branch_id, study_admit_type_id, study_plan_id, study_classes_id, specific_nation_id, faculty_id, order, additional_data }) {
    let send_data = {};
    send_data.function = 'get-name-list-summary';
    send_data.YEAR_ID = year_id;
    if (round_id) send_data.ROUND_ID = round_id;
    if (faculty_id) send_data.MASTER_REG_FACULTY_ID = faculty_id;
    if (project_id) send_data.PROJECT_ID = project_id;
    if (master_reg_curriculum_id) send_data.MASTER_REG_CURRICULUM_ID = master_reg_curriculum_id;
    if (register_status_id) send_data.REGISTER_STATUS_ID = register_status_id;
    if (static_list) send_data.static_list = true;
    if (branch_id) send_data.BRANCH_ID = branch_id;
    if (study_admit_type_id) send_data.STUDY_ADMIT_TYPE_ID = study_admit_type_id;
    if (study_plan_id) send_data.STUDY_PLAN_ID = study_plan_id;
    if (study_classes_id) send_data.STUDY_CLASSES_ID = study_classes_id;
    if (specific_nation_id) send_data.SPECIFIC_NATION_ID = specific_nation_id;
    if (refused) send_data.REFUSED = refused;
    if (order) send_data.ORDER = order;
    if (additional_data) send_data = { ...send_data, ...additional_data }
    const { data } = await this.get('/', send_data)
    return data
  }

  async getPreExecutedNameListSummary({ year_id, round_id, project_id, master_reg_curriculum_id, register_status_id, static_list, refused, branch_id, study_admit_type_id, study_plan_id, study_classes_id, specific_nation_id, faculty_id, order, additional_data }) {
    let send_data = {};
    send_data.function = 'get-pre-executed-register-name-list-summary';
    send_data.YEAR_ID = year_id;
    if (round_id) send_data.ROUND_ID = round_id;
    if (faculty_id) send_data.MASTER_REG_FACULTY_ID = faculty_id;
    if (project_id) send_data.PROJECT_ID = project_id;
    if (master_reg_curriculum_id) send_data.MASTER_REG_CURRICULUM_ID = master_reg_curriculum_id;
    if (register_status_id) send_data.REGISTER_STATUS_ID = register_status_id;
    if (static_list) send_data.static_list = true;
    if (branch_id) send_data.BRANCH_ID = branch_id;
    if (study_admit_type_id) send_data.STUDY_ADMIT_TYPE_ID = study_admit_type_id;
    if (study_plan_id) send_data.STUDY_PLAN_ID = study_plan_id;
    if (study_classes_id) send_data.STUDY_CLASSES_ID = study_classes_id;
    if (specific_nation_id) send_data.SPECIFIC_NATION_ID = specific_nation_id;
    if (refused) send_data.REFUSED = refused;
    if (order) send_data.ORDER = order;
    if (additional_data) send_data = { ...send_data, ...additional_data }
    const { data } = await this.get('/', send_data)
    return data
  }

  async getCurriculumOrderCountSummary(year_id) {
    const { data } = await this.get('/', {
      function: 'get-curriculum-order-count-summary',
      YEAR_ID: year_id,
    })
    return data
  }

  async getPreExecutedRegister({ YEAR_ID, ROUND_ID, PROJECT_ID, FACULTY_ID }) {
    const { data } = await this.get('/', {
      function: 'get-pre-executed-register',
      YEAR_ID, ROUND_ID, PROJECT_ID, FACULTY_ID
    })
    return data
  }

  async setPreExecutedRegister({ YEAR_ID, ROUND_ID, PROJECT_ID, FACULTY_ID, register_list }) {
    const { data } = await this.update('/', {
      function: 'set-pre-executed-register',
      YEAR_ID, ROUND_ID, PROJECT_ID, FACULTY_ID, register_list: [register_list]
    })
    return data
  }

  async setPreExecutedRegisterLock({
    YEAR_ID,
    ROUND_ID,
    PROJECT_ID,
    FACULTY_ID,
    MASTER_REG_CURRICULUM_ID,
    BRANCH_ID,
    STUDY_ADMIT_TYPE_ID,
    STUDY_PLAN_ID,
    STUDY_CLASSES_ID,
    SPECIFIC_NATION_ID,
    lock
  }) {
    const { data } = await this.update('/', {
      function: 'confirm-pre-executed-register',
      YEAR_ID,
      ROUND_ID,
      PROJECT_ID,
      FACULTY_ID,
      MASTER_REG_CURRICULUM_ID,
      BRANCH_ID,
      STUDY_ADMIT_TYPE_ID,
      STUDY_PLAN_ID,
      STUDY_CLASSES_ID,
      SPECIFIC_NATION_ID,
      set_lock: lock
    })
    return data
  }

  async publish({
    YEAR_ID,
    ROUND_ID,
    PROJECT_ID,
    FACULTY_ID,
    MASTER_REG_CURRICULUM_ID,
    BRANCH_ID,
    STUDY_ADMIT_TYPE_ID,
    STUDY_PLAN_ID,
    STUDY_CLASSES_ID,
    SPECIFIC_NATION_ID,
    mode,
  }) {
    const { data } = await this.update('/', {
      function: 'apply-pre-executed-register',
      YEAR_ID,
      ROUND_ID,
      PROJECT_ID,
      FACULTY_ID,
      MASTER_REG_CURRICULUM_ID,
      BRANCH_ID,
      STUDY_ADMIT_TYPE_ID,
      STUDY_PLAN_ID,
      STUDY_CLASSES_ID,
      SPECIFIC_NATION_ID,
      mode,
    })
    return data
  }

  async getExecuteIndex({ YEAR_ID, ROUND_ID, PROJECT_ID }) {
    const { data } = await this.get('/', {
      function: 'get-executed-index',
      YEAR_ID, ROUND_ID, PROJECT_ID
    })
    return data
  }

  async getNotPaidTuitionFee() {
    const { data } = await this.get('/', {
      function: 'get-not-paid-tuition-fee',
    })
    return data
  }
}

export default ReportsProvider